
import { Component } from '@theme/component';

class StickyCard extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.card = this.querySelector('[data-sticky-card]');
    if (!this.card || window.matchMedia('(max-width: 767px)').matches) return;

    this.stop = document.querySelector(this.dataset.stopSelector || '.footer-banner');
    this.state = '';

    this.update = this.update.bind(this);
    this.measure = this.measure.bind(this);
    window.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.measure);
    window.addEventListener('load', this.measure);

    this.observer = new ResizeObserver(() => requestAnimationFrame(this.measure));
    this.observer.observe(document.body);

    this.measure();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.measure);
    window.removeEventListener('load', this.measure);
    this.observer?.disconnect();
  }

  measure() {
    const styles = getComputedStyle(this);
    this.bottom = parseFloat(styles.getPropertyValue('--sticky-card-bottom')) || 24;
    this.gap = parseFloat(styles.getPropertyValue('--sticky-card-gap')) || 24;

    this.setState('');
    this.height = this.card.offsetHeight;
    this.cardTop = this.card.getBoundingClientRect().top + window.scrollY;
    this.hostBottom = this.getBoundingClientRect().bottom + window.scrollY;

    const stopTop = this.stop
      ? this.stop.getBoundingClientRect().top + window.scrollY
      : this.hostBottom;
    this.parkAt = stopTop - this.gap - window.innerHeight + this.bottom;
    this.style.setProperty('--sticky-card-park', `${Math.round(this.hostBottom - stopTop + this.gap)}px`);

    this.update();
  }

  update() {
    const y = window.scrollY;
    if (y >= this.parkAt) this.setState('is-parked');
    else this.setState('is-fixed');
  }

  setState(next) {
    if (this.state === next) return;
    this.card.classList.remove('is-fixed', 'is-parked');
    if (next) this.card.classList.add(next);
    this.state = next;
  }
}

if (!customElements.get('sticky-card-component')) customElements.define('sticky-card-component', StickyCard);
